export const AMPLITUDE = {
  COURSES_FILTER: 'Courses Filter',
  COURSES_SEARCH: 'Courses Search',
  COURSES_DETAIL: 'Courses Detail',
  COURSES_SORT: 'Courses Sort',
  COURSES_PAGINATION: 'Courses Pagination',
};
